/**
 * getMobiusEndpoint.js
 *
 * Utility for getting the mobius endpoint based on the host environment
 */

const getMobiusEndpoint = (host) => {
  const staging = 'https://api.staging.mobius.highereducation.com';
  const prod = 'https://api.mobius.highereducation.com';
  // Check if BC dev
  if (host === 'dev.bestcolleges.com') {
    return staging;
  }

  // check if host contains pantheon (lower lanes and multidevs)
  if (host.includes('pantheonsite')) {
    return staging;
  }

  // check if local
  if (host === 'localhost' || host === '127.0.0.1' || host.includes('lndo')) {
    return staging;
  }

  // if no dev requirements are met, return false
  return prod;
};

export default getMobiusEndpoint;
